import { render, staticRenderFns } from "./jurnal.vue?vue&type=template&id=3f2810d8"
import script from "./jurnal.vue?vue&type=script&lang=js"
export * from "./jurnal.vue?vue&type=script&lang=js"
import style0 from "./jurnal.vue?vue&type=style&index=0&id=3f2810d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports